import store from "@/store";

export function ConvertProductData(productData) {
  let gtm_product = {
    item_id: productData.GoodsID,
    item_name: productData.Title,
    item_brand: GetCompanyName(),
    price: parseInt(GetLowPrice(productData.Stock)),
    item_variant: GetVariant(productData.Stock),
    item_list_id: productData.Menu.length > 0 ? productData.Menu[0].MenuID : "",
    index: productData.Seq,
    currency: "TWD",
  };

  for (let i = 1; i <= 5; i++) {
    if (productData.Menu.length >= i) {
      i == 1
        ? (gtm_product.item_category = productData.Menu[i - 1].Title)
        : (gtm_product[`item_category${i}`] = productData.Menu[i - 1].Title);
    }
  }
  return gtm_product;
}

export function ConvertAddShopCartData(productData, activeOption, amount) {
  const option_text =
    productData.IsCustom == "Y"
      ? GetCustomOptionText(productData, activeOption)
      : GetOptionText(productData, activeOption);
  const price = GetSellPrice(productData, activeOption);

  let gtm_product = {
    item_id: productData.GoodsID,
    item_name: productData.Title,
    quantity: amount,
    item_brand: GetCompanyName(),
    price: parseInt(price),
    item_variant: option_text,
    item_list_id: productData.Menu.length > 0 ? productData.Menu[0].MenuID : "",
    index: productData.Seq,
    currency: "TWD",
  };

  for (let i = 1; i <= 5; i++) {
    if (productData.Menu.length >= i) {
      i == 1
        ? (gtm_product.item_category = productData.Menu[i - 1].Title)
        : (gtm_product[`item_category${i}`] = productData.Menu[i - 1].Title);
    }
  }
  return gtm_product;
}

export function GetCompanyName() {
  const column = store.state.commonColumnData.filter(
    (column) => column.Title == "company_name"
  );
  return column.length <= 0 ? "" : column[0].Content;
}

export function GetLowPrice(stocks) {
  let price = 9999;
  stocks.forEach((item) => {
    parseInt(item.SellPrice) < price ? (price = parseInt(item.SellPrice)) : "";
  });
  return price == 9999 ? 0 : price;
}

export function GetVariant(stocks) {
  return stocks.length > 0
    ? `${stocks[0].ColorTitle},${stocks[0].SizeTitle}`
    : "";
}

export function GTM_AddPaymentInfo(shopcart, payment_id) {
  const payment_type = store.state.paymentData.filter(
    (item) => item.PaymentID == payment_id
  )[0];

  let products = [];

  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item.productData,
      item.activeOption,
      item.amount
    );
    products.push(product);
  });
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "addPaymentInfo",
      items: products,
      value: 0,
      currency: "TWD",
      payment_type: payment_type.FrontTitle,
    });
  }
}

export function GTM_AddShipInfo(shopcart, shipping_id, ship_price) {
  const shipway = store.state.shipwayData.filter(
    (item) => item.ShippingID == shipping_id
  )[0];

  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item.productData,
      item.activeOption,
      item.amount
    );
    products.push(product);
  });

  if (window.dataLayer) {
    window.dataLayer.push({
      event: "addShippingInfo",
      items: products,
      value: 0,
      currency: "TWD",
      shipping: ship_price,
      shipping_tier: shipway.Title,
    });
  }
}

export function GTM_BeginCheckout(shopcart) {
  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item.productData,
      item.activeOption,
      1
    );
    products.push(product);
  });
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "beginCheckout",
      items: products,
      value: 0,
      currency: "TWD",
    });
  }
}

export function GTM_Purchase(shopcart, trade_data, coupon_info) {
  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item.productData,
      item.activeOption,
      item.amount
    );
    products.push(product);
  });
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "purchase",
      trade_no: trade_data.TradeID,
      items: products,
      value: trade_data.Price,
      currency: "TWD",
      tax: 0,
      shipping: trade_data.ShippingFee,
      coupon: coupon_info,
    });
  }
}

export function GTM_AddShopCart(shopcart_item, amount) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "add_to_cart",
      items: [
        ConvertAddShopCartData(
          shopcart_item.productData,
          shopcart_item.activeOption,
          amount
        ),
      ],
      value: 0,
      currency: "TWD",
    });
  }
}

export function GTM_RemoveShopCart(shopcart_item, amount) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "remove_from_cart",
      items: [
        ConvertAddShopCartData(
          shopcart_item.productData,
          shopcart_item.activeOption,
          amount
        ),
      ],
      value: 0,
      currency: "TWD",
    });
  }
}

export function GTM_OpenShopCart(shopcart) {
  let products = [];
  shopcart.forEach((item) => {
    const product = ConvertAddShopCartData(
      item.productData,
      item.activeOption,
      1
    );
    products.push(product);
  });
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "view_cart",
      items: products,
      value: 0,
      currency: "TWD",
    });
  }
}

export function GTM_ViewProduct(productData) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "viewProduct",
      items: [ConvertProductData(productData)],
      value: 0,
      currency: "TWD",
    });
  }
}

export function GTM_ViewItemList(category_title, category_id) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "viewItemList",
      item_list_name: category_title,
      item_list_id: category_id,
      value: 0,
      currency: "TWD",
    });
  }
}

export function GTM_CustomEvent(event_name) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event_name: event_name,
      event: "custom_event",
    });
  }
}

// 更新Cookie與廣告資料搜集
export function GTM_UpdateConsent(action) {
  if (window.dataLayer) {
    window.dataLayer.push({
      event: "update_consent",
      ad_storage: action ? "granted" : "denied",
      analytics_storage: action ? "granted" : "denied",
      functionality_storage: action ? "granted" : "denied",
      personalization_storage: action ? "granted" : "denied",
      security_storage: action ? "granted" : "denied",
      ad_user_data: action ? "granted" : "denied",
      ad_personalization: action ? "granted" : "denied",
    });
  }
}

function GetCustomOptionText(productData, options) {
  let option_text = "";
  options.forEach((option) => {
    const spec = productData.CustomSpecList.filter(
      (item) => item.CustomSpecID == option
    )[0];
    option_text != "" ? (option_text += "/") : "";
    option_text += spec.SpecCategoryTitle + ":" + spec.SpecTitle;
  });
  return option_text;
}

function GetOptionText(productData, options) {
  let option_text = "";
  const ColorTitle = productData.Stock.filter(
    (stock) => stock.ColorID == options[0]
  )[0].ColorTitle;
  const SizeTitle = productData.Stock.filter(
    (stock) => stock.SizeID == options[1]
  )[0].SizeTitle;

  option_text += productData.Option1 + ":" + ColorTitle;
  if (SizeTitle != "無") {
    option_text += "/" + productData.Option2 + ":" + SizeTitle;
  }

  return option_text;
}

function GetSellPrice(productData, options) {
  if (productData.IsCustom == "Y") {
    return productData.CustomGoodsStock[0].SellPrice;
  } else {
    const Price = productData.Stock.filter(
      (stock) => stock.SizeID == options[1] && stock.ColorID == options[0]
    )[0].SellPrice;

    return Price;
  }
}
